import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import { ChevronUp } from '@finect/tabular-icons/chevronUp';
var Inner = styled.div.withConfig({
  displayName: "CollapsibleContentSmall__Inner",
  componentId: "sc-m0fmlj-0"
})(["display:block;"]);
var Header = styled.div.withConfig({
  displayName: "CollapsibleContentSmall__Header",
  componentId: "sc-m0fmlj-1"
})(["cursor:pointer;text-align:", ";", " svg{margin-right:3px;vertical-align:text-top;}", ""], function (_ref) {
  var _ref$titleAlign = _ref.titleAlign,
    titleAlign = _ref$titleAlign === void 0 ? 'left' : _ref$titleAlign;
  return titleAlign;
}, function (_ref2) {
  var theme = _ref2.theme,
    themeColor = _ref2.themeColor;
  return themeColor && "color: ".concat(theme[themeColor], "; font-weight: 700;");
}, function (_ref3) {
  var withBackground = _ref3.withBackground;
  return withBackground && css(["border:1px solid ", ";border-radius:4px;background-color:", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.ui;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.ui;
  });
});
var Content = styled.div.withConfig({
  displayName: "CollapsibleContentSmall__Content",
  componentId: "sc-m0fmlj-2"
})(["display:", ";"], function (_ref6) {
  var _ref6$collapsed = _ref6.collapsed,
    collapsed = _ref6$collapsed === void 0 ? false : _ref6$collapsed;
  return collapsed ? 'none' : 'block';
});
export var CollapsibleContentSmall = function CollapsibleContentSmall(props) {
  var _useState = useState(props.collapsed || false),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var handleClick = function handleClick() {
    setCollapsed(!collapsed);
  };
  useEffect(function () {
    setCollapsed(props.collapsed || false);
  }, [props.collapsed]);
  var title = props.title,
    titleAlign = props.titleAlign,
    _props$titlePosition = props.titlePosition,
    titlePosition = _props$titlePosition === void 0 ? 'top' : _props$titlePosition,
    children = props.children,
    disabled = props.collapseDisabled,
    color = props.color,
    _props$chevronSize = props.chevronSize,
    chevronSize = _props$chevronSize === void 0 ? '18' : _props$chevronSize,
    _props$chevronWidth = props.chevronWidth,
    chevronWidth = _props$chevronWidth === void 0 ? '2' : _props$chevronWidth,
    _props$chevronPositio = props.chevronPosition,
    chevronPosition = _props$chevronPositio === void 0 ? 'left' : _props$chevronPositio;
  return React.createElement(Inner, {
    collapsed: collapsed
  }, titlePosition === 'top' && !disabled ? React.createElement(Header, {
    collapsed: collapsed,
    onClick: handleClick,
    titleAlign: titleAlign,
    themeColor: color
  }, chevronPosition !== 'left' ? null : collapsed ? React.createElement(ChevronRight, {
    size: chevronSize,
    strokeWidth: chevronWidth
  }) : React.createElement(ChevronDown, {
    size: chevronSize,
    strokeWidth: chevronWidth
  }), title, chevronPosition !== 'right' ? null : collapsed ? React.createElement(ChevronRight, {
    size: chevronSize,
    strokeWidth: chevronWidth
  }) : React.createElement(ChevronDown, {
    size: chevronSize,
    strokeWidth: chevronWidth
  })) : null, React.createElement(Content, {
    collapsed: collapsed
  }, children), titlePosition === 'bottom' && !disabled ? React.createElement(Header, {
    collapsed: collapsed,
    onClick: handleClick,
    titleAlign: titleAlign,
    themeColor: color
  }, chevronPosition !== 'left' ? null : collapsed ? React.createElement(ChevronRight, {
    size: chevronSize,
    strokeWidth: chevronWidth
  }) : React.createElement(ChevronUp, {
    size: chevronSize,
    strokeWidth: chevronWidth
  }), title, chevronPosition !== 'right' ? null : collapsed ? React.createElement(ChevronRight, {
    size: chevronSize,
    strokeWidth: chevronWidth
  }) : React.createElement(ChevronUp, {
    size: chevronSize,
    strokeWidth: chevronWidth
  })) : null);
};